import { useState } from 'react';
import undieslogo from '../images/undieslogo.png';
import cmdrbriefs from '../images/cmdrbriefs.png';


const USER_NAMES = { A: 'Sarah', B: 'Chance' };
const USER_NICKNAMES = { A: 'crotes', B: 'ponyboy' };


// ─── Interview questions ───────────────────────────────────────────────────────
// Each question has a 'question' string and a 'choices' array.
// Each choice has a 'text' string and a 'user' value of 'A' or 'B'.
// The user with the majority of answers (3 of 5) is determined as the player.
const QUESTIONS = [
  {
    question: 'How many hot dogs, including buns, could you eat in one sitting?',
    choices: [
      { text: 'What\'s the condiment situation?', user: 'B' },
      { text: 'Depends on how much I\'ve eaten that day', user: 'B' },
      { text: 'At least 4-6', user: 'B' },
      { text: 'Ew meat and bread', user: 'A' },
    ],
  },
  {
    question: 'What\'s your ideal Saturday afternoon crafting session?',
    choices: [
      { text: 'Stained glass', user: 'A' },
      { text: 'Painting', user: 'A' },
      { text: 'Crafting some Z\'s (taking a nap)', user: 'B' },
    ],
  },
  {
    question: 'How long do you think you would survive in a realistic zombie survival scenario?',
    choices: [
      { text: 'How long do I have to prepare?', user: 'B' },
      { text: 'Depends on starting location and what supplies I have access to', user: 'B' },
      { text: 'At least 6 months', user: 'B' },
      { text: 'Under the right conditions, almost indefinitely', user: 'B' },
      { text: 'Do I have to?', user: 'A' },
    ],
  },
  {
    question: 'Booty booty booty booty, but where is it rockin?',
    choices: [
      { text: 'Everywhere, obviously', user: 'A' },
      { text: 'Please don\'t do this to me, it\'s my day off', user: 'B' },
    ],
  },
  {
    question: 'Which type of movies is best?',
    choices: [
      { text: 'Horror', user: 'B' },
      { text: 'Pixar', user: 'A' },
      { text: 'Marvel', user: 'A' },
      { text: 'A24', user: 'B' },
      { text: 'Dubbed Korean Action Movies', user: 'B' },
      { text: 'Anything where they steal the declaration of independence', user: 'B' },
    ],
  },
    {
    question: 'Would you rather be a ...?',
    choices: [
      { text: 'Nen user', user: 'B' },
      { text: 'Fae warrior princess', user: 'A' },
      { text: 'Jujutsu sorcerer', user: 'B' },
      { text: 'Mermaid', user: 'A' },
      { text: 'Demon slayer', user: 'B' },
      { text: 'Woodland witch', user: 'A' },
      { text: 'Super Saiyan', user: 'B' },
    ],
  },
    {
    question: 'On which floor was your freshman dormitory?',
    choices: [
      { text: 'Second', user: 'B' },
      { text: 'Third', user: 'A' },
      { text: 'I don\'t remember', user: 'B' },
    ],
  },
];

function LoginScreen({ onLogin }) {
  // viewIndex: 0 = intro, 1–5 = questions, 6 = result
  const [viewIndex, setViewIndex] = useState(0);
  const [answers, setAnswers] = useState([]);

  function handleBegin() {
    setViewIndex(1);
  }

  function handleChoice(user) {
    const newAnswers = [...answers, user];
    setAnswers(newAnswers);
    if (newAnswers.length === QUESTIONS.length) {
      setViewIndex(QUESTIONS.length + 1);
    } else {
      setViewIndex((v) => v + 1);
    }
  }

  function handleReset() {
    setViewIndex(0);
    setAnswers([]);
  }

  function getDeterminedUser() {
    const aCount = answers.filter((a) => a === 'A').length;
    return aCount > answers.length / 2 ? 'A' : 'B';
  }

  // ── View 1: Intro ──────────────────────────────────────────────────────────
  if (viewIndex === 0) {
    return (
      <div className="screen">
        <div className="screen-content">
          <h1 className="screen-title">Agent Authorization</h1>
          <img src={cmdrbriefs} alt="commander briefs" className="block-image" />
          <p className="block-text">
             We hope you'll pardon the formality, but before we can move forward, we need to make absolutely certain of your identity.
          </p>
          <p className="block-text">
            Answer the following questions to the best of your ability to proceed with identity verification and agent authorization.
          </p>
          <p className="block-text">
            - Commander Briefs
          </p>
        </div>
        <div className="nav-buttons">
          <button className="btn btn-primary" onClick={handleBegin}>
            Begin
          </button>
        </div>
      </div>
    );
  }

  // ── Views 2–6: Questions ───────────────────────────────────────────────────
  if (viewIndex >= 1 && viewIndex <= QUESTIONS.length) {
    const q = QUESTIONS[viewIndex - 1];
    return (
      <div className="screen">
        <div className="screen-content">
          <p className="quiz-progress">
            Question {viewIndex} of {QUESTIONS.length}
          </p>
          <p className="quiz-question">{q.question}</p>
          <div className="choices">
            {q.choices.map((choice, i) => (
              <button
                key={i}
                className="btn choice-btn"
                onClick={() => handleChoice(choice.user)}
              >
                {choice.text}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // ── View 7: Result ─────────────────────────────────────────────────────────
  const determinedUser = getDeterminedUser();
  const userName = USER_NAMES[determinedUser];
  const nickname = USER_NICKNAMES[determinedUser];
  return (
    <div className="screen">
      <div className="screen-content">
        <h1 className="screen-title">Identity confirmed.</h1>
        <p className="block-text">
          After processing your answers through our advanced identity determination and verification algorithm, we have determined that you are:
        </p>
        <p className="quiz-result-name">{userName}</p>
        <p className="block-text">
          Knew it was you all along, {nickname}.
        </p>
        <img src={undieslogo} alt="U.N.D.I.E.S logo" className="block-image" />
      </div>
      <div className="nav-buttons">
        <button className="btn btn-secondary" onClick={handleReset}>
          Try again
        </button>
        <button className="btn btn-primary" onClick={() => onLogin(determinedUser)}>
          Proceed
        </button>
      </div>
    </div>
  );
}

export default LoginScreen;